// extracted by mini-css-extract-plugin
export default {"tip":"PdfWorkWithPagesPromo__tip--3svp0","text":"PdfWorkWithPagesPromo__text--3SVIc"};